import { useEffect, useState } from 'react';
import styles from '../styles/cardselect.module.css';
import ButtonOverride from './buttonoverride';
import { useField } from 'formik';
import useApi from '../hooks/use-api';
import { useModalStatusContext } from '../contexts/modalstatuscontext';
import NonExpandableSearchBox from './nonexpandablesearchbox';
import SelectSkeleton from './selectskeleton';
import InsetAlert from './insetalert';

const CardSelect = ({fieldName,objectName,suppliedItems,retrieveDataEndpoint = null,extractDataFunction = null}) => {
    const [field,meta,helpers] = useField(fieldName);
    const [items,setItems] = useState([]);
    const [searchTerm,setSearchTerm] = useState('');
    const [filteredItems,setFilteredItems] = useState([]);
    
    const {processing, error, getRequest} = useApi();
    const {setLoading,handleError} = useModalStatusContext();
    
    
    useEffect(() => {
        if(retrieveDataEndpoint){
            setLoading(true);
            const get = async () => {
            const [data, status] = await getRequest(retrieveDataEndpoint, {timestamp: Date.now()}); 
            if (status === 200) {
                let values = data;
                if(extractDataFunction){
                    values = extractDataFunction(data);
                }
                setItems(values);
                setFilteredItems(values);
                setLoading(false);
            }
            else{
                setItems([]);
                setLoading(false);
                handleError(error);
            }
        };

        get();

        }
        else{
            setItems(suppliedItems);
        }
    },[])

    useEffect(() => {
        const filteredResult = items.filter(item => item.name.toLowerCase().includes(searchTerm.toLowerCase())).sort((a,b) => a.name.localeCompare(b.name));
        setFilteredItems(filteredResult);
    },[searchTerm,items]);

    const isSelected = (itemId) => {
        return field.value.includes(itemId);
    }

    const handleItemClick = (itemId) => {
        if(!field.value.includes(itemId)){
            const newValues = [...field.value,itemId].sort((a,b) => a - b);
            helpers.setValue(newValues);
        }
        else{
            helpers.setValue(field.value.filter((id) => itemId !== id).sort((a,b) => a - b));
        }
    }

    const renderCards = (filteredItems,searchText) => {
        return(
            items.length
            ?
                <div className={styles.mainContainer}>
                    <div className={styles.searchContainer}>
                            <NonExpandableSearchBox id={`search_${fieldName}`} style={{color: 'black'}} placeholder={`Search ${objectName}'s`} searchTerm={searchTerm} setSearchTerm={setSearchTerm} value={searchTerm} onChange={(e) => setSearchTerm(e.target.value)}/>
                    </div>
                    {
                        filteredItems.length > 0
                        ?
                            <div className={styles.selectCardContainer}>
                            {
                                filteredItems.map((item,index) => (
                                    <button key={index} className={`${styles.selectCard} ${isSelected(item.id) ? styles.active : styles.inactive}`} onClick={() => handleItemClick(item.id)} type='button' aria-label={`${isSelected(item.id) ? 'Deselect Role' : 'Select Role'}`}>
                                        <span className='h5 d-block'>{item.name}</span>
                                        <span className='small d-block'>{item.description}</span>
                                    </button>
                                ))
                            }
                            </div>
                        :
                            searchText !== "" && <div className={styles.noResults}>No Results Found</div>
                    }
                </div>
            :
                <div className={styles.noResults}>No {objectName} Exist</div>
                
        )
            
    }

    return(
        processing
        ?
            <SelectSkeleton />
        :
            error
            ?
                <InsetAlert error={error} dismissible={false} style={{width: '100%'}}/>
            :
                renderCards(filteredItems,searchTerm,suppliedItems)
    )
}

export default CardSelect;